export const findPhoneData = (indexesArr, phoneId, isIndex) => {
  if (isIndex) {
    return (phoneId && "+" + indexesArr?.find((index) => index?.id === phoneId)?.phone_index) || "";
  } else {
    return phoneId && indexesArr?.find((index) => index?.id === phoneId);
  }
};
